import axios from "axios";
import {API_URL} from "./index";





class ApiImportService {
    loadFilms = (params) => {
        const url = API_URL.filmRelease("find-pending-acceptance");
        return axios.get(url, {params}).then(response => response.data);
    };
    submitAccept = (payload) => {

        const url = API_URL.filmRelease("accept-api-release");
        return axios.put(url, payload).then(response => response.data);
    };
    matchFilms = (externalId, internalId) => {
        const url = API_URL.filmRelease(`match-api-release/${externalId}/to/${internalId}`);
        return axios.put(url).then(response => response.data);
    };
    countFilmsToAccept = () => {
        const url = API_URL.filmRelease("count-pending-acceptance");
        return axios.get(url).then(response => response.data);
    };
}
export default new ApiImportService();
